import type { Components } from '@mui/material/styles';

export default function MUIGrid(): Components['MuiGrid'] {
  return {};
}
